import { createApp } from "vue";
import loginApp from "./login-app.vue";
import Maska from "maska";

const application = createApp(loginApp);
application.use(Maska);
application.mount("#loginApp");
